// extracted by mini-css-extract-plugin
module.exports = {"si-wrapper":"TermsOfService_si-wrapper__2FUEp","silc-btn":"TermsOfService_silc-btn__22VT9","root":"TermsOfService_root__YB9-b","lastUpdated":"TermsOfService_lastUpdated__13BAl"};